import styled from 'styled-components';

export const PageHeading = styled.h1`
    margin-bottom: ${props => props.theme.spacing[7]};
`;
